import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHomeLine: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconHomeLine"><Path fillRule="evenodd" clipRule="evenodd" d="M21 8.52405L12 1.21155L3 8.52405V21H21V8.52405ZM7 15V17H17V15H7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHomeLine;
